import { Grid, Container, Button, Typography } from '@mui/material';
import './HomePage.scss';
import AboutUs from './components/AboutUs';
import History from './components/History';
import Vision from './components/Vision';
import ContactForm from './components/ContactForm';

export default function HomePage() {
    return (
        <Container className="home-page">
            <Typography variant="h2" className="section-title" style={{ color: '#808080' }} gutterBottom>
                世界创世集团
            </Typography>
            <Typography variant="h5" color="textSecondary" paragraph>
                探索未来科技的无限可能
            </Typography>

            <Button
                variant="contained"
                color="primary"
                className="shine-button"
                href="https://qm.qq.com/qq群链接"
                target="_blank"
                sx={{ mb: 4 }}
            >
                加入QQ交流群
            </Button>

            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <AboutUs />
                </Grid>
                <Grid item xs={12} md={6}>
                    <History />
                </Grid>
                <Grid item xs={12}>
                    <Vision />
                </Grid>
                <Grid item xs={12} md={8} sx={{ margin: '0 auto' }}>
                    <ContactForm />
                </Grid>
            </Grid>
        </Container>
    );
}
